import styles from './index.module.css'
import cn from 'clsx'

import React from 'react'
import { Separator as RadixSeparator } from 'components/ds'
type Props = {
  or?: boolean
}

/**
 * Separator component for login form sections with optional 'OR' text
 * Provides visual separation between different login methods
 * @param or - Whether to display 'OR' text in the separator
 */
const Separator = ({ or }: Props): React.ReactNode => (
  <RadixSeparator
    size="4"
    mt="4"
    mb="4"
    className={cn(styles.Separator, {
      [styles.Separator_Or]: or,
    })}
  />
)

export default Separator
